(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('merimofa-catalog:not([data-ready])').forEach((catalog) => {
      catalog.dataset.ready = 'true';
      const sectionId = catalog.dataset.sectionId;
      const grid = document.querySelector(`#product-grid[data-id="${sectionId}"]`);

      if (!grid) return;

      const buttons = [...catalog.querySelectorAll('[data-catalog-filter]')];
      const items = [...grid.querySelectorAll('[data-catalog-item]')];
      const count = catalog.querySelector('[data-catalog-count]');
      const label = catalog.querySelector('[data-catalog-label]');

      const applyFilter = (filter) => {
        let visibleCount = 0;

        items.forEach((item) => {
          const visible = filter === 'all' || item.dataset.catalogItem === filter;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        buttons.forEach((button) => {
          const active = button.dataset.catalogFilter === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });

        if (count) count.textContent = visibleCount;
        if (label) label.textContent = visibleCount === 1 ? 'oil' : 'oils';
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => applyFilter(button.dataset.catalogFilter));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
